import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import { GlobalShell } from "~/components/GlobalShell";
import { useRouter, useSearchParams } from "~/components/navigation";
import { trpc } from "~/utils/trpc.client";

export const Route = createFileRoute("/verify-email-confirm")({
  component: VerifyEmailConfirmPage,
});

function VerifyEmailConfirmPage() {
  const router = useRouter();
  const token = useSearchParams().get("token");
  const verifyEmail = trpc.auth.verifyEmail.useMutation();
  // verifyEmail sets a session cookie, so `auth.me` becomes available and tells
  // us whether the person already has a password (the old route.ts looked this
  // up directly via SQL to choose which success page to land on).
  const utils = trpc.useUtils();
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;
    fired.current = true;

    if (!token) {
      router.replace("/verify-email-failure");
      return;
    }

    verifyEmail.mutate(
      { token },
      {
        onSuccess: () => {
          void (async () => {
            try {
              const me = await utils.auth.me.fetch();
              router.replace(
                me.hasPassword
                  ? "/verify-email-success"
                  : "/verify-email-success-set-password",
              );
            } catch {
              router.replace("/verify-email-success-set-password");
            }
          })();
        },
        onError: () => {
          router.replace("/verify-email-failure");
        },
      },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <GlobalShell>
      <div className="flex grow items-center justify-center">
        <div className="card bg-base-100 w-96 shadow-xl max-w-[90vw]">
          <div className="card-body">
            <p>Verifying...</p>
          </div>
        </div>
      </div>
    </GlobalShell>
  );
}
